/**
 * The access type.
 */
export enum AccessType
{
  View = "View",
  Edit = "Edit",
  Create = "Create",
  Delete = "Delete",
}